import { Monitor, Smartphone, Rocket } from 'lucide-react';
import { api } from '../lib/spizirnaUi';

/**
 * Nastavení → Pokladny → Verze aplikací.
 *
 * Vydané verze POS a FofrTelefonu. Nová verze jde nejdřív na testovací
 * kanál (vyzkouší ji terminál přepnutý na „Testovací"), pak se povýší na
 * stabilní a dostanou ji všechny. Stažená verze se nenabízí — když nová
 * zlobí, stáhne se a terminály si při „Aktualizovat teď" vezmou předchozí.
 *
 * Vydává se skriptem `npm run vydat` v POSu (telefon `telefon/vydat.sh`).
 */
export default function AplikaceVerze({ verze, isDark, muted, border, kartaBg, onZmena, onAktualizovatVse }) {
    const uprav = (v, zmena) => api(`/api/aplikace-verze/${v.id}`, 'PUT', zmena).then(onZmena).catch(() => onZmena());

    return (
        <div className="space-y-2 pt-2">
            <div className="flex items-center gap-2">
                <h4 className="text-xs font-semibold uppercase tracking-wide flex-1" style={{ color: muted }}>Verze aplikací</h4>
                <button onClick={onAktualizovatVse}
                    className="flex items-center gap-1.5 text-xs font-semibold rounded-lg px-3 py-1.5"
                    style={{ background: 'rgba(59,130,246,0.12)', border: '1px solid rgba(59,130,246,0.4)', color: '#3b82f6', cursor: 'pointer' }}>
                    <Rocket size={13} /> Aktualizovat všechny teď
                </button>
            </div>
            <p className="text-xs" style={{ color: muted }}>
                Pokladna novou verzi stáhne na pozadí a nainstaluje ji sama, až nebude mít rozdělaný účet a chvíli s ní nikdo nepracuje.
                Telefon ukáže výzvu k instalaci.
            </p>

            {verze.length === 0 && <p className="text-xs" style={{ color: muted }}>Zatím žádná vydaná verze.</p>}

            {verze.map(v => {
                const Ikona = v.aplikace === 'telefon' ? Smartphone : Monitor;
                const test = v.kanal === 'testovaci';
                return (
                    <div key={v.id} className="flex flex-wrap items-center gap-3 rounded-xl px-4 py-2.5"
                        style={{ background: kartaBg, border: `1px solid ${border}`, opacity: v.aktivni ? 1 : 0.5 }}>
                        <Ikona size={15} style={{ color: muted }} />
                        <span className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>
                            {v.aplikace === 'telefon' ? 'FofrTelefon' : 'POS'} <span className="font-mono">{v.verze}</span>
                        </span>
                        <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full"
                            style={{ background: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)', color: test ? 'var(--text-secondary)' : '#10b981' }}>
                            {!v.aktivni ? 'stažená' : test ? 'testovací' : 'stabilní'}
                        </span>
                        <span className="text-[11px]" style={{ color: muted }}>
                            {(v.velikost / 1048576).toFixed(1)} MB · {new Date(v.created_at).toLocaleString('cs-CZ', { day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit' })}
                            {v.poznamka ? ` · ${v.poznamka}` : ''}
                        </span>
                        <div className="ml-auto flex gap-1.5">
                            {v.aktivni && test && (
                                <button onClick={() => uprav(v, { kanal: 'stabilni' })}
                                    className="text-[11px] font-semibold rounded-lg px-2.5 py-1"
                                    style={{ background: '#10b981', color: '#fff', border: 'none', cursor: 'pointer' }}>
                                    Povýšit na stabilní
                                </button>
                            )}
                            <button onClick={() => uprav(v, { aktivni: !v.aktivni })}
                                className="text-[11px] font-semibold rounded-lg px-2.5 py-1"
                                style={{ background: 'transparent', border: `1px solid ${border}`, color: v.aktivni ? '#EF4444' : muted, cursor: 'pointer' }}>
                                {v.aktivni ? 'Stáhnout' : 'Vrátit'}
                            </button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
